/* Medicus — default fit and size (dtc_experiments: default-effect, week of 26 Oct 2026)

   On multi-fit scrub cap listings only, tick "The Captain" in the
   "Your Scrub Cap Fit / Style" group and "M/L Captain" in "Scrub Cap Size"
   before the customer touches anything, so the page opens on the fit and
   size most people order instead of on a blank required group. Then write
   one line under the size group pointing at the head-measure page.

   Both ticks go through input.click(), the same path assets/mc-personalised.js
   restore() uses, so YMQ's own change handlers, conditions and sku string run
   exactly as for a human tap.

   Guards (all deliberate):
   - never ticks a value that carries a price (The Pony +£2 is never a default)
   - never touches colour, lining, embroidery, name, terms or any add-on
   - does nothing with ?mc-edit= in the URL (the cart-edit restore owns the form)
   - does nothing if any fit or size radio is already checked
   - never re-applies after the customer changes anything
   - one pass, then stops; gives up after 15 s
   - every DOM write carries data-mc-default so the other body observers
     (fit card, sticky bar, fold, a11y) cannot loop on it

   Config comes from the JSON in snippets/mc-default-fit.liquid. Delete the
   render line in layout/theme.liquid and all of this is gone. */
(function () {
  'use strict';
  if (window.__mcDefaultFit) return;
  window.__mcDefaultFit = true;

  if (new URLSearchParams(location.search).has('mc-edit')) return;

  var cfgEl = document.querySelector('script[data-mc-default-config]');
  var cfg;
  try { cfg = JSON.parse(cfgEl ? cfgEl.textContent : '{}'); } catch (e) { return; }
  var FIT_PREFIX = cfg.fit_prefix || 'The Captain';
  var SIZE_PREFIX = cfg.size_prefix || 'M/L Captain';
  var FIT_RE = /Fit \/ Style/i;
  var SIZE_RE = /^Scrub Cap Size/i;
  var GIVE_UP_MS = 15000;

  var started = Date.now();
  var customerTouched = false;
  var fitDone = false;
  var sizeDone = false;
  var noteDone = false;

  function boxes() { return Array.prototype.slice.call(document.querySelectorAll('.ymq-options-box[ymq-option-label]')); }
  function label(b) { return b.getAttribute('ymq-option-label') || ''; }
  function shown(el) { return !!(el && (el.offsetWidth || el.offsetHeight)); }
  function boxFor(re) { return boxes().filter(function (b) { return re.test(label(b)); })[0] || null; }
  function radios(box) { return Array.prototype.slice.call(box.querySelectorAll('input[type="radio"]')); }
  function anyChecked(box) { return !!(box && box.querySelector('input[type="radio"]:checked, input[type="checkbox"]:checked')); }

  /* A value with a price is never a default. YMQ prints the surcharge in
     .ymq-option-price next to the value; "(+£2.00)" in the value text is the
     fallback. */
  function hasPrice(inp) {
    var item = inp.closest('.ymq-option-value-item') || inp.parentElement;
    var pe = item && item.querySelector('.ymq-option-price');
    var txt = ((pe && pe.textContent) || '') + ' ' + (inp.value || '');
    var m = txt.match(/[+]\s*[£$€]?\s*(\d+(?:[.,]\d+)?)/);
    return !!(m && parseFloat(m[1].replace(',', '.')) > 0);
  }

  function tick(box, prefix) {
    var list = radios(box);
    for (var i = 0; i < list.length; i++) {
      var inp = list[i];
      if ((inp.value || '').indexOf(prefix) !== 0) continue;
      if (hasPrice(inp)) return false;
      if (!shown(inp.closest('.ymq-option-value-item') || inp.parentElement)) continue;
      if (!inp.checked) {
        box.setAttribute('data-mc-default', 'ticking');
        inp.click();
        box.setAttribute('data-mc-default', 'ticked');
      }
      return true;
    }
    return false;
  }

  function writeNote(sizeBox) {
    if (noteDone || !cfg.note) return;
    if (sizeBox.querySelector('.mc-default-note')) { noteDone = true; return; }
    var el = document.createElement('div');
    el.className = 'mc-default-note';
    el.setAttribute('data-mc-default', 'note');
    var parts = String(cfg.note).split(cfg.link_text || '\u0000');
    el.appendChild(document.createTextNode(parts[0]));
    if (parts.length > 1 && cfg.link_text && cfg.link_href) {
      var a = document.createElement('a');
      a.href = cfg.link_href;
      a.textContent = cfg.link_text;
      el.appendChild(a);
      el.appendChild(document.createTextNode(parts.slice(1).join(cfg.link_text)));
    }
    sizeBox.appendChild(el);
    noteDone = true;
  }

  /* Any real (isTrusted) change by the customer on the YMQ form ends the pass. */
  document.addEventListener('change', function (ev) {
    if (!ev.isTrusted) return;
    if (ev.target && ev.target.closest && ev.target.closest('.ymq-options-box')) customerTouched = true;
  }, true);
  document.addEventListener('pointerdown', function (ev) {
    if (ev.target && ev.target.closest && ev.target.closest('.ymq-options-box')) customerTouched = true;
  }, true);

  function step() {
    if (customerTouched) return;
    if (Date.now() - started > GIVE_UP_MS) return;

    var fitBox = boxFor(FIT_RE);
    if (!fitBox) { setTimeout(step, 250); return; }          /* not a multi-fit listing yet, or not rendered */
    if (!shown(fitBox)) { setTimeout(step, 250); return; }

    var sizeBox = boxFor(SIZE_RE);

    if (!fitDone) {
      if (anyChecked(fitBox) || (sizeBox && anyChecked(sizeBox))) return;   /* back navigation / YMQ-remembered state: leave it */
      if (!tick(fitBox, FIT_PREFIX)) return;                /* no Captain at base price here: do nothing at all */
      fitDone = true;
      setTimeout(step, 300);
      return;
    }

    if (!sizeDone) {
      sizeBox = boxFor(SIZE_RE);
      if (!sizeBox || !shown(sizeBox)) { setTimeout(step, 250); return; }
      if (!anyChecked(sizeBox)) tick(sizeBox, SIZE_PREFIX);
      sizeDone = true;
      writeNote(sizeBox);
      return;                                                /* one pass, then stop */
    }
  }

  function boot() {
    var tries = 0;
    (function waitForForm() {
      if (customerTouched) return;
      if (document.querySelector('.ymq-options-box[ymq-option-label]')) { step(); return; }
      if (++tries < 60) setTimeout(waitForForm, 250);
    })();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
